<template>
  <b-modal
    id="tenancy-selection-modal"
    ref="tenancySelectionModal"
    centered
    size="lg"
    :title="$t('message.onBoarding.buildings.objects.notificationChangeTenant')"
    hide-footer>
    <div class="row">
      <div class="col-12 col-md-6">
        <handover-tenancy-move
          ref="moving-in-tenancies-card"
          :object="object"
          from-handover="moveIn"
          :available-contact="updatedAvailableContacts"
          :move-tenancies="updatedMovingInTenancies"
          :preselected-contact-persons="preselectedContactPersons"
          :from-notification-change-tenant="true"
          @move-in-tenancy-selected="moveInTenancySelected"
          @move-in-contact-persons-selected="moveInContactPersonsSelected"
          @contact-updated="contactUpdated" />
      </div>
      <div class="col-12 col-md-6">
        <handover-tenancy-move
          ref="moving-out-tenancies-card"
          from-handover="moveOut"
          :object="object"
          :available-contact="updatedAvailableContacts"
          :move-tenancies="updatedMovingOutTenancies"
          :preselected-contact-persons="preselectedContactPersons"
          :from-notification-change-tenant="true"
          @move-out-tenancy-selected="moveOutTenancySelected"
          @move-out-contact-persons-selected="moveOutContactPersonsSelected"
          @contact-updated="contactUpdated" />
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <coozzy-button
        size="small"
        class="border mb-0 mr-2"
        design="transparent"
        @click="$bvModal.hide('tenancy-selection-modal')">
        {{ $t('message.generic.cancel') }}
      </coozzy-button>
      <coozzy-button
        size="small"
        class="mb-0"
        design="green"
        :disabled="!canProceed"
        @click="proceed">
        {{ $t('message.generic.next') }}
      </coozzy-button>
    </div>
  </b-modal>
</template>

<script>
import HandoverTenancyMove from '@/handover/component/HandoverTenancyMove.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'

export default {
  name: 'TenancySelectionModal',
  components: {
    HandoverTenancyMove,
    CoozzyButton
  },
  props: {
    object: {
      type: Object,
      required: true
    },
    availableContacts: {
      type: Array,
      default: () => []
    },
    movingInTenancies: {
      type: Array,
      default: () => []
    },
    movingOutTenancies: {
      type: Array,
      default: () => []
    },
    preselectedContactPersons: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedMovingInTenancy: null,
      selectedMovingOutTenancy: null,
      selectedMovingInContactPersons: [],
      selectedMovingOutContactPersons: [],
      updatedMovingInTenancies: [],
      updatedMovingOutTenancies: [],
      updatedAvailableContacts: []
    }
  },
  computed: {
    canProceed() {
      return this.selectedMovingInTenancy || this.selectedMovingOutTenancy
    }
  },
  watch: {
    availableContacts: {
      handler(newContacts) {
        this.updatedAvailableContacts = [...newContacts]
      },
      deep: true
    }
  },
  mounted() {
    if (!this.updatedMovingInTenancies.length && this.movingInTenancies.length) {
      this.updatedMovingInTenancies = [...this.movingInTenancies]
    }
    if (!this.updatedMovingOutTenancies.length && this.movingOutTenancies.length) {
      this.updatedMovingOutTenancies = [...this.movingOutTenancies]
    }
    this.updatedAvailableContacts = [...this.availableContacts]
  },
  methods: {
    show() {
      this.$bvModal.show('tenancy-selection-modal')
    },
    updateTenancies(movingInTenancies, movingOutTenancies) {
      this.updatedMovingInTenancies = [...movingInTenancies]
      this.updatedMovingOutTenancies = [...movingOutTenancies]

      if (this.$refs['moving-in-tenancies-card']) {
        this.$refs['moving-in-tenancies-card'].moveTenancies = movingInTenancies
      }

      if (this.$refs['moving-out-tenancies-card']) {
        this.$refs['moving-out-tenancies-card'].moveTenancies = movingOutTenancies
      }
    },
    moveInTenancySelected(tenancy) {
      this.selectedMovingInTenancy = tenancy
    },
    moveOutTenancySelected(tenancy) {
      this.selectedMovingOutTenancy = tenancy
    },
    moveInContactPersonsSelected(contactPersons) {
      this.selectedMovingInContactPersons = contactPersons
    },
    moveOutContactPersonsSelected(contactPersons) {
      this.selectedMovingOutContactPersons = contactPersons
    },
    contactUpdated(updatedContact) {
      const contactIndex = this.updatedAvailableContacts.findIndex(contact => contact.id === updatedContact.id)
      if (contactIndex !== -1) {
        this.updatedAvailableContacts[contactIndex] = {
          ...this.updatedAvailableContacts[contactIndex],
          name: updatedContact.name,
          email: updatedContact.email,
          phoneNumbers: updatedContact.phoneNumbers,
          website: updatedContact.website
        }
      }

      this.$emit('contact-updated', updatedContact)
    },
    proceed() {
      this.$emit('proceed', {
        movingInTenancy: this.selectedMovingInTenancy,
        movingOutTenancy: this.selectedMovingOutTenancy
      })
      this.$bvModal.hide('tenancy-selection-modal')
    }
  }
}
</script>
